import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
import { useLayoutEffect, useRef, useState } from "react";
import {
  ERROR_COLOR,
  ORANGE_COLOR,
  PRIMARY_COLOR,
  SUCCESS_DARK_COLOR,
  SUCCESS_LIGHT_COLOR,
} from "theme/variable";

export default function StackChart({
  height = 300,
  data = [],
  yField = "box",
}) {
  const chartRef = useRef();
  const [uniqId] = useState(Math.random());
  const CONTAINER_ID = `chart_div_${uniqId}`;
  useLayoutEffect(() => {
    if (chartRef.current) {
      var root = am5.Root.new(CONTAINER_ID);

      // Set themes
      // https://www.amcharts.com/docs/v5/concepts/themes/
      root.setThemes([am5themes_Animated.new(root)]);

      let chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: false,
          panY: false,
          wheelX: "panX",
          wheelY: "zoomX",
          layout: root.verticalLayout,
        })
      );
      // Add scrollbar
      // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
      // chart.set(
      //   "scrollbarX",
      //   am5.Scrollbar.new(root, {
      //     orientation: "horizontal",
      //   })
      // );
      // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
      let xRenderer = am5xy.AxisRendererX.new(root, {});
      let xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "week_num",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {}),
        })
      );

      xRenderer.grid.template.setAll({
        location: 1,
      });

      xAxis.data.setAll(data);

      let yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          min: 0,
          renderer: am5xy.AxisRendererY.new(root, {
            strokeOpacity: 0.1,
          }),
        })
      );

      // Add legend
      // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
      let legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.p50,
          x: am5.p50,
        })
      );

      //get the color
      function getColor(type) {
        let color = "";
        // if (type === "Paid") color = SUCCESS_COLOR;
        if (type === "Paid Sub Orders") color = SUCCESS_DARK_COLOR;
        if (type === "OneOff Orders") color = SUCCESS_LIGHT_COLOR;
        if (type === "Pending") color = PRIMARY_COLOR;
        if (type === "Canceled") color = "#000";
        if (type === "Skipped") color = ORANGE_COLOR;
        if (type === "Refunded") color = "purple";
        if (type === "Failed") color = ERROR_COLOR;
        return color;
      }

      // Add series
      // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
      function makeSeries(name, fieldName) {
        let series = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: name,
            stacked: true,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: fieldName,
            categoryXField: "week_num",
          })
        );

        series.columns.template.setAll({
          tooltipText: "{categoryX} week: {name} {valueY}",
          tooltipY: am5.percent(10),
          fill: getColor(name),
        });
        series.data.setAll(data);

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        series.appear();

        // series.bullets.push(function () {
        //   return am5.Bullet.new(root, {
        //     sprite: am5.Label.new(root, {
        //       text: "{valueY}",
        //       fill: getColor(name),
        //       centerY: am5.p50,
        //       centerX: am5.p50,
        //       populateText: true,
        //     }),
        //   });
        // });

        legend.data.push(series);
      }

      // makeSeries("Paid", yField === "boxes" ? "paid" : "pie_paid");
      makeSeries(
        "Paid Sub Orders",
        yField === "boxes" ? "paidSub" : "pie_paidSub"
      );
      makeSeries(
        "OneOff Orders",
        yField === "boxes" ? "paidOneOff" : "pie_paidOneOff"
      );
      makeSeries("Pending", yField === "boxes" ? "pending" : "pie_pending");
      makeSeries("Failed", yField === "boxes" ? "failed" : "pie_failed");
      makeSeries("Refunded", yField === "boxes" ? "refund" : "pie_refund");
      makeSeries("Skipped", yField === "boxes" ? "skipped" : "pie_skipped");
      makeSeries("Canceled", yField === "boxes" ? "canceled" : "pie_canceled");
      // series.appear();
      chart.appear(1000, 100);
      root?._logo?.dispose();
    }
    return () => {
      root.dispose();
    };
  }, [CONTAINER_ID, data, yField]);

  return (
    <div
      id={CONTAINER_ID}
      style={{ width: "100%", height: height }}
      ref={chartRef}
    />
  );
}
